import { render, staticRenderFns } from "./BillboardFileViewer.vue?vue&type=template&id=50552c8e&scoped=true&"
import script from "./BillboardFileViewer.vue?vue&type=script&lang=ts&"
export * from "./BillboardFileViewer.vue?vue&type=script&lang=ts&"
import style0 from "./BillboardFileViewer.vue?vue&type=style&index=0&id=50552c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50552c8e",
  null
  
)

export default component.exports